import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginPage.vue'),
    meta: { hideNavbar: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/RegisterPage.vue'),
    meta: { hideNavbar: true }
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/HomePage.vue')
  },
  {
    path: '/products',
    name: 'ProductList',
    component: () => import('../views/ProductListPage.vue')
  },
  {
    path: '/products/:id',
    name: 'ProductDetail',
    component: () => import('../views/ProductDetailPage.vue')
  },
  {
    path: '/order/confirm',
    name: 'OrderConfirm',
    component: () => import('../views/OrderConfirmPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/order/detail',
    name: 'OrderDetail',
    component: () => import('../views/OrderDetailPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/order/payment-success',
    name: 'PaymentSuccess',
    component: () => import('../views/PaymentSuccessPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/marketplace',
    name: 'MarketplaceList',
    component: () => import('../views/MarketplaceListPage.vue')
  },
  {
    path: '/marketplace/:id',
    name: 'MarketplaceDetail',
    component: () => import('../views/MarketplaceDetailPage.vue')
  },
  {
    path: '/publish/product',
    name: 'PublishProduct',
    component: () => import('../views/PublishProductPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/publish/marketplace',
    name: 'PublishMarketplace',
    component: () => import('../views/PublishMarketplacePage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/ProfilePage.vue'),
    redirect: '/profile/info',
    children: [
      {
        path: 'info',
        name: 'ProfileInfo',
        component: () => import('../views/profile/ProfileInfo.vue')
      },
      {
        path: 'contracts',
        name: 'Contracts',
        component: () => import('../views/profile/Contracts.vue')
      },
      {
        path: 'purchases',
        name: 'Purchases',
        component: () => import('../views/profile/Purchases.vue')
      },
      {
        path: 'listings',
        name: 'Listings',
        component: () => import('../views/profile/Listings.vue')
      },
      {
        path: 'favorites',
        name: 'Favorites',
        component: () => import('../views/profile/Favorites.vue')
      },
      {
        path: 'history',
        name: 'BrowsingHistory',
        component: () => import('../views/profile/BrowsingHistory.vue')
      },
      {
        path: 'negotiations',
        name: 'Negotiations',
        component: () => import('../views/profile/Negotiations.vue')
      },
      {
        path: 'wallet',
        name: 'Wallet',
        component: () => import('../views/profile/Wallet.vue')
      },
      {
        path: 'invites',
        name: 'InviteList',
        component: () => import('../views/profile/InviteList.vue')
      },
      {
        path: 'verification',
        name: 'Verification',
        component: () => import('../views/profile/Verification.vue')
      }
    ]
  },
  {
    path: '/api-test',
    name: 'ApiTest',
    component: () => import('../views/ApiTestPage.vue')
  },
  {
    path: '/help',
    name: 'Help',
    component: () => import('../views/HelpPage.vue')
  },
  {
    path: '/blacklist',
    name: 'Blacklist',
    component: () => import('../views/BlacklistPage.vue')
  },
  {
    path: '/trade-protection',
    name: 'TradeProtection',
    component: () => import('../views/TradeProtectionPage.vue')
  },
  {
    path: '/escrow-guarantee',
    name: 'EscrowGuarantee',
    component: () => import('../views/EscrowGuaranteePage.vue')
  },
  {
    path: '/service-agreement',
    name: 'ServiceAgreement',
    component: () => import('../views/ServiceAgreementPage.vue')
  },
  {
    path: '/after-sales',
    name: 'AfterSales',
    component: () => import('../views/AfterSalesPage.vue')
  },
  {
    path: '/about/advantages',
    name: 'AboutAdvantages',
    component: () => import('../views/about/AdvantagesPage.vue')
  },
  {
    path: '/about/company',
    name: 'AboutCompany',
    component: () => import('../views/about/CompanyPage.vue')
  },
  {
    path: '/about/business',
    name: 'AboutBusiness',
    component: () => import('../views/about/BusinessPage.vue')
  },
  {
    path: '/about/equipment',
    name: 'AboutEquipment',
    component: () => import('../views/about/EquipmentPage.vue')
  },
  {
    path: '/platform-intro',
    name: 'PlatformIntro',
    component: () => import('../views/footer/PlatformIntroPage.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/footer/ContactPage.vue')
  },
  {
    path: '/join-us',
    name: 'JoinUs',
    component: () => import('../views/footer/JoinUsPage.vue')
  },
  {
    path: '/friend-links',
    name: 'FriendLinks',
    component: () => import('../views/footer/FriendLinksPage.vue')
  },
  {
    path: '/guide/beginner',
    name: 'BeginnerGuide',
    component: () => import('../views/footer/BeginnerGuidePage.vue')
  },
  {
    path: '/trade-process',
    name: 'TradeProcess',
    component: () => import('../views/footer/TradeProcessPage.vue')
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import('../views/footer/FAQPage.vue')
  },
  {
    path: '/guarantee',
    name: 'Guarantee',
    component: () => import('../views/footer/GuaranteePage.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/yingtao',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 浏览器前进/后退时恢复原来的位置
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})

export default router
